
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { PanelSectionTitle } from '../../core';

const Coordinate = (props) => {

    const classNames = mergeStyleSets({
        root: {
            paddingLeft: 16,
            paddingTop: 2,
            paddingBottom: 2
        },
        value: {
            width: 90
        }
    });

    const getValue = (value) => {
        return value.toFixed(2);
    }

    return (
        <Stack horizontal className={classNames.root}>
            <div className={classNames.value}>{getValue(props.coordinate.x)}</div>
            <div className={classNames.value}>{getValue(props.coordinate.y)}</div>
            <div className={classNames.value}>{getValue(props.coordinate.z)}</div>
        </Stack>
    );
}

const Coordinates = (props) => {

    const classNames = mergeStyleSets({
        root: {
        },
    });

    return (
        <div className={classNames.root}>
            <PanelSectionTitle title="Seznam souřadnic aktuálního měření v S-JTSK" />
            {props.coordinates.map((item, index) => {
                return (
                    <Coordinate key={index} coordinate={item} />
                );
            })}
        </div>
    );
}

export default Coordinates;
